// extracted by mini-css-extract-plugin
module.exports = {"action-control":"action-control--ovjpg","info":"info--4nHpq","action-btn":"action-btn--cCaF5","form":"form--wrv4U"};